module.exports = __webpack_public_path__ + "static/twitter-2cf89dd332f4a1a2a543d839e0a7b7fb.png";